import React from "react";

import { ElementState } from "@creatomate/preview";
import { getTimelineElementName, getTimelineElementText } from "../utils";

interface BarTextProps {
  currentElement: ElementState;
  isSmallElement: boolean;
}

const BarText: React.FC<BarTextProps> = ({
  currentElement,
  isSmallElement
}) => {
  if (currentElement.source.type === "text") {
    return <span>{getTimelineElementText(currentElement, isSmallElement)}</span>;
  }

  return <span>{getTimelineElementName(currentElement, isSmallElement)}</span>;
};

export default BarText;
